<template>
  <g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.7045 4.44782C21.6082 4.69423 22.3197 5.42031 22.5612 6.34226L22.5611 6.34235C23 8.01342 23 11.5001 23 11.5001C23 11.5001 23 14.9866 22.5611 16.6578C22.3196 17.5798 21.6081 18.3058 20.7044 18.5524C19.0669 19 12.4999 19 12.4999 19C12.4999 19 5.93304 19 4.29539 18.5524C3.39182 18.3057 2.68012 17.5798 2.43876 16.6577C2 14.9865 2 11.5 2 11.5C2 11.5 2 8.01333 2.43876 6.34226C2.68012 5.42031 3.39182 4.69423 4.29548 4.44782C5.93313 4 12.5 4 12.5 4C12.5 4 19.067 4 20.7045 4.44782ZM16 11.5002L9.875 14.5882V8.41174L16 11.5002Z"
    />
  </g>
</template>
